export const ApplicationModuleName = 'app';
export const RouterModuleName = "ROUTER_MODULE_NAME";
export const AngularJsMaterialModuleName = 'ngMaterial';
export const MainModuleName = "MAIN_MODULE_NAME";
export const MainServiceModuleName = "AUTHENTICATION_MODULE_NAME";
export const LoaderModuleName = "LOADER_MODULE";
export const NgRouteModuleName = 'ngRoute';
export const MdTableModuleName = 'md.data.table';
export const UtilsModuleName = 'UTILS_MODULE_NAME';
export const AngularBootstrapUi = 'ui.bootstrap';
export const OpportunityNotificationModuleName = "OPPORTUNITY_NOTIFICATION_MODULE_NAME";
export const MaterialConfigurationsModuleName = 'MaterialConfigurationsModuleName';